import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl, CustomFormSelect } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';
import { Options } from '../SelectOptions';

export const Schema = (settings) => Yup.object().shape({
    university: checkRequiredText(settings),
    currentSemester: Yup.number().typeError("Ungültige Zahl").required("Angabe ist erforderlich").positive("Ungültige Eingabe"),
});

export const StudyOfTraineeSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId='abiturnote'>
                <Form.Label>Abiturnote</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder={'Abiturnote'}
                    type="number"
                    name='abiturnote'
                    value={values.abiturnote || ''}
                    isValid={touched.abiturnote && !errors.abiturnote}
                    isInvalid={errors.abiturnote}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.abiturnote}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='university'>
                <Form.Label>Aktuelle / Letzte Universität*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='university'
                    value={values.university}
                    isValid={touched.university && !errors.university}
                    isInvalid={touched.university && errors.university}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.Universities.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.university}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='currentSemester'>
                <Form.Label>Aktuelles Semester*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder='Aktuelles Semester'
                    type="number"
                    name='currentSemester'
                    value={values.currentSemester || ''}
                    isValid={touched.currentSemester && !errors.currentSemester}
                    isInvalid={touched.currentSemester && errors.currentSemester}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.currentSemester}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Text muted>Mehrere Scheinnoten durch Kommata trennen.</Form.Text>
            <Form.Group className="mb-3" controlId='gradePublicLaw'>
                <Form.Label>Scheinnoten Öffentliches Recht</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder='Scheinnoten Öffentliches Recht'
                    type="text"
                    name='gradePublicLaw'
                    value={values.gradePublicLaw}
                    isValid={touched.gradePublicLaw && !errors.gradePublicLaw}
                    isInvalid={errors.gradePublicLaw}
                    maxLength={settings.textInputLimit}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.gradePublicLaw}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='gradeCriminalLaw'>
                <Form.Label>Scheinnoten Strafrecht</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder='Scheinnoten Strafrecht'
                    type="text"
                    name='gradeCriminalLaw'
                    value={values.gradeCriminalLaw}
                    isValid={touched.gradeCriminalLaw && !errors.gradeCriminalLaw}
                    isInvalid={errors.gradeCriminalLaw}
                    maxLength={settings.textInputLimit}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.gradeCriminalLaw}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='gradeCivilLaw'>
                <Form.Label>Scheinnoten Zivilrecht</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder='Scheinnoten Zivilrecht'
                    type="text"
                    name='gradeCivilLaw'
                    value={values.gradeCivilLaw}
                    isValid={touched.gradeCivilLaw && !errors.gradeCivilLaw}
                    isInvalid={errors.gradeCivilLaw}
                    maxLength={settings.textInputLimit}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.gradeCivilLaw}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='otherGrades'>
                <Form.Label>Sonstige Scheinnoten</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder='Sonstige Scheinnoten'
                    type="text"
                    name='otherGrades'
                    value={values.otherGrades}
                    isValid={touched.otherGrades && !errors.otherGrades}
                    isInvalid={errors.otherGrades}
                    maxLength={settings.textInputLimit}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.otherGrades}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};